/**
 * BRASS FOR HOMES — Theme JavaScript
 * Scroll-triggered animations, smooth interactions
 */

(function() {
  'use strict';

  // ===== Scroll Animation Observer =====
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        
        // Stagger children if present
        var children = entry.target.querySelectorAll('.stagger-child');
        children.forEach(function(child, i) {
          child.style.transitionDelay = (i * 0.1) + 's';
          child.classList.add('is-visible');
        });

        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px'
  });

  // Observe all fade-in elements
  document.querySelectorAll('.fade-in').forEach(function(el) {
    observer.observe(el);
  });

  // ===== Header Scroll Behavior =====
  var header = document.querySelector('.site-header');
  var lastScroll = 0;

  if (header) {
    window.addEventListener('scroll', function() {
      var currentScroll = window.pageYOffset;
      
      if (currentScroll > 80) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }

      if (currentScroll > lastScroll && currentScroll > 200) {
        header.style.transform = 'translateY(-100%)';
      } else {
        header.style.transform = 'translateY(0)';
      }

      lastScroll = currentScroll;
    }, { passive: true });
  }

  // ===== Close nav overlay on Escape =====
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var overlay = document.getElementById('nav-overlay');
      if (overlay) overlay.classList.remove('is-open');
    }
  });

  // ===== Smooth scroll for anchor links =====
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ===== Product Page Cache Rescue =====
  // Some Shopify page-cache entries can hold old product HTML after a theme fix.
  // The variant query forces a fresh product render while keeping Shopify's canonical URL intact.
  function withVariantBypass(href) {
    if (!href) return href;

    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return href;
    }

    if (url.origin !== window.location.origin || url.pathname.indexOf('/products/') !== 0) {
      return href;
    }

    if (!url.searchParams.has('variant')) {
      url.searchParams.set('variant', '');
    }

    return url.pathname + url.search + url.hash;
  }

  function normalizeProductLinks() {
    document.querySelectorAll('a[href*="/products/"]').forEach(function(link) {
      var href = link.getAttribute('href');
      var nextHref = withVariantBypass(href);
      if (nextHref && nextHref !== href) {
        link.setAttribute('href', nextHref);
      }
    });
  }

  normalizeProductLinks();

  document.addEventListener('click', function(e) {
    var link = e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (!link) return;

    var href = link.getAttribute('href');
    var nextHref = withVariantBypass(href);
    if (nextHref && nextHref !== href) {
      e.preventDefault();
      window.location.href = nextHref;
    }
  }, true);

  if (window.location.pathname.indexOf('/products/') === 0) {
    var current = new URL(window.location.href);
    if (!current.searchParams.has('variant') && !current.searchParams.has('view') && !current.searchParams.has('preview_theme_id')) {
      current.searchParams.set('variant', '');
      window.location.replace(current.pathname + current.search + current.hash);
    }
  }

  window.changeImage = function(thumbOrUrl) {
    var mainImage = document.getElementById('main-product-image');
    if (!mainImage) return;

    var src = '';
    var srcset = '';
    var alt = '';

    if (thumbOrUrl && typeof thumbOrUrl.getAttribute === 'function') {
      src = thumbOrUrl.getAttribute('data-src') || '';
      srcset = thumbOrUrl.getAttribute('data-srcset') || '';
      alt = thumbOrUrl.getAttribute('data-alt') || '';
    } else if (typeof thumbOrUrl === 'string') {
      src = thumbOrUrl;
    }

    if (src) mainImage.src = src;
    if (srcset) {
      mainImage.srcset = srcset;
    } else {
      mainImage.removeAttribute('srcset');
    }
    if (alt) mainImage.alt = alt;

    if (thumbOrUrl && thumbOrUrl.classList) {
      document.querySelectorAll('.product-gallery__thumb').forEach(function(thumb) {
        thumb.classList.remove('is-active');
      });
      thumbOrUrl.classList.add('is-active');
    }
  };

})();
